import { client } from 'repositories/client';
import { paths } from 'repositories/webclip/paths';
import { SessionResponse } from 'repositories/webclip/responseType';

const session = async (token: string): Promise<SessionResponse> => {
  const params = new FormData();
  params.append('onetime_token', token);

  const response = await client.post<SessionResponse>(paths.session, params);

  return response.data;
};

export const webclip = {
  session,
};
